import { Card, CardContent } from "@/components/ui/card";
import { Bot, Target, GraduationCap, Megaphone, ChartBar, MessageSquare } from "lucide-react";

export const ServicesGrid = () => {
  const services = [
    {
      icon: <Bot className="h-8 w-8 text-blue-600" />,
      title: "AI Student Support",
      description: "24/7 intelligent assistance for student queries, course guidance, and administrative support through AI-powered chatbots."
    },
    {
      icon: <Target className="h-8 w-8 text-blue-600" />,
      title: "Smart Lead Generation",
      description: "AI-powered lead capture and nurturing systems that identify and engage prospective students throughout their decision journey."
    },
    {
      icon: <GraduationCap className="h-8 w-8 text-blue-600" />,
      title: "Enrollment Intelligence",
      description: "Smart AI systems that optimize admission processes, predict enrollment trends, and enhance student recruitment."
    },
    {
      icon: <Megaphone className="h-8 w-8 text-blue-600" />,
      title: "Intelligent Marketing",
      description: "AI-driven marketing automation that delivers personalized campaigns, optimizes ad spend, and increases enrollment conversions."
    },
    {
      icon: <ChartBar className="h-8 w-8 text-blue-600" />,
      title: "Academic Analytics",
      description: "AI-powered insights into student performance, course effectiveness, and institutional metrics for data-driven decisions."
    },
    {
      icon: <MessageSquare className="h-8 w-8 text-blue-600" />,
      title: "Communication Hub",
      description: "Automated communication systems that streamline student-faculty interactions and deliver timely updates across channels."
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-black mb-12">
          AI-Powered Educational Solutions
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-3 text-black">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};